import React from "react";
import "./Footer.css";
import logo from "../../images/logo.png";
const Footer = () => {
  return (
    <div className="footer-container mt-12">
      <div className="grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-1 sm:grid-cols-1 pt-8  mt-2   text-white pb-12">
        <div>
          <img className=" w-3/6 pl-24 animate-pulse" src={logo} alt="" />
          <br />
          <p>
            <small>© 2021 Doctor Bari. All Rights Reserved</small>
          </p>
        </div>
        <div>
          <h3 className="text-xl text-white font-bold">Contact Us</h3>
          <br />
          <a href="#">
            <i className="fas fa-phone"></i> Call Us : 01789879345
          </a>
          <br />
          <a href="#">
            <i className="fab fa-whatsapp"></i> What's App : 01789879345
          </a>
        </div>
        <div>
          <h3 className="text-xl text-white font-bold">Social Media</h3>
          <div className="pt-8 text-2xl">
            <i className="fab fa-facebook-f pl-4"></i>
            <i className="fab fa-twitter pl-4"></i>
            <i className="fab fa-linkedin-in pl-4"></i>
            <i className="fab fa-instagram pl-4"></i>
            <i className="fab fa-youtube pl-4"></i>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
